import React, { Component, Fragment } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Loader } from '@components/common';

class Notes extends Component {
	shouldComponentUpdate = ({ data, loading }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.data, data)
			|| !isEqual(lastProps.loading, loading)
		);
	};

	render() {
		const { data, loading } = this.props;
		return (
			<Fragment>
				<Choose>
					<When condition={data.length}>
						<For
							each="item"
							of={data}
						>
							<div
								key={item.id}
								className="margin-bottom-20"
							>
								<div className="flex margin-bottom-5">
									<span className="flex-2">
										<span className="font-size-12 font-regular-italic padding-2">{ item.title }</span>
									</span>
									<span className="flex-2 text-right font-size-12">{ item.date }</span>
								</div>
								<span className="font-size-12">{ item.note }</span>
							</div>
						</For>
					</When>
					<Otherwise>
						<div className="margin-bottom-10 margin-top-10 flex-center">
							<span className="font-size-14 font-light">No Notes.</span>
						</div>
					</Otherwise>
				</Choose>
				<Loader active={loading} />
			</Fragment>
		);
	}
}

Notes.propTypes = {
	data    : PropTypes.array,
	loading : PropTypes.bool,
};

Notes.defaultProps = {
	data    : [],
	loading : false,
};

export default Notes;
